import { motion } from "framer-motion";
import styled from "styled-components";
import { Button } from "../Button/Button.styled";
import { device } from "../../style";

export const KycModalWrapper = styled(motion.div)<{ isFullHeight?: boolean }>`
  display: flex;
  flex: ${({ isFullHeight }) => (isFullHeight ? "1" : "unset")};
  height: ${({ isFullHeight }) => (isFullHeight ? "80%" : "unset")};
  position: ${({ isFullHeight }) => (isFullHeight ? "absolute" : "unset")};
  left: 0;
  min-width: 100%;
  top: 0;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;

  @media ${device.laptopM} {
    height: ${({ isFullHeight }) => (isFullHeight ? "85%" : "unset")};
  }
`;

export const Title = styled.div`
  color: #08a98a;
  line-height: 35px;
  font-family: Ingra;
  font-size: 32px;
  font-weight: 300;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  text-transform: uppercase;
`;

export const TitleSpan = styled.span`
  font-weight: 700;
  margin-right: 8px;
  color: #08a98a;
`;

export const InitKycButton = styled(Button.Primary)`
  height: 56px;
  border-radius: 16px;
`;

export const PoweredText = styled.p`
  font-family: Ingra;
  font-size: 7px;
  font-weight: 300;
  line-height: 9.52px;
  letter-spacing: 0.15em;
  text-align: left;
  text-transform: uppercase;
`;

export const SumsubLogo = styled.img`
  width: auto;
  height: 100px;
  object-fit: contain;
`;

export const KycModalContent = styled.div`
  font-family: Ingra;
  font-size: 14px;
  font-weight: 300;
  line-height: 19.04px;
  text-align: left;
  color: #000;
  width: 100%;
`;

export const SelectVerificationTypeHeader = styled.p`
  font-family: Ingra;
  font-size: 18px;
  font-weight: 400;
  color: #000;
  margin-bottom: 20px;
`;

export const VerificationTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
`;

export const VerificationTypeOption = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex: 1;
  border-radius: 8px;
  background-color: #222;
  border: 4px solid ${({ selected }) => (selected ? "#26a677" : "transparent")};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  }
`;

export const VerificationTypeTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #fff;
`;

export const VerificationTypeDescription = styled.p`
  font-size: 14px;
  color: #e4e4e4;
`;

export const VerificationTypeLabel = styled.span`
  display: inline-block;
  color: #08a98a;
  font-weight: 500;
`;
